import { jsx as _jsx } from "react/jsx-runtime";
import { ChainOrderStoreProvider } from './chains';
import { RouteExecutionStoreProvider } from './routes';
import { SettingsStoreProvider } from './settings';
export const StoreProvider = ({ children, namePrefix }) => {
    return (_jsx(RouteExecutionStoreProvider, Object.assign({ namePrefix: namePrefix }, { children: _jsx(SettingsStoreProvider
        // namePrefix={namePrefix}
        , { children: _jsx(ChainOrderStoreProvider
            // namePrefix={namePrefix}
            , { children: children }) }) })));
};
